<div class="user-card">
  <div class="user-avatar" aria-hidden="true">
    {{ userMock.iniziali }}
  </div>

  <div class="user-info">
    <span class="user-name title-medium">{{ userMock.nome }}</span>
    <span class="user-role body-medium">{{ userMock.ruolo }}</span>
  </div>
</div>

<span class="my-activities title-large-emphasized">Le tue attività</span>

<button
  matButton="filled"
  type="button"
  class="desktop-new-revenue-button"
  *uiCan="CAPS.incassoCrea"
  [routerLink]="newReceiptLink"
>
  <i class="fa-regular fa-plus" aria-hidden="true"></i>
  Nuovo incasso
</button>

<a class="activity-card activity-card-link" [routerLink]="inProgressLink">
  <div class="activity-icon" aria-hidden="true">
    <i class="fa-regular fa-file-text"></i>
  </div>

  <div class="activity-info">
    <span class="title-medium-emphasized">Incassi in lavorazione</span>
    <span class="body-medium">Incassi raccolti dai clienti non ancora finalizzati</span>
  </div>

  <span class="activity-count label-small-emphasized">
    {{ incassiCount }}
  </span>

  <span class="activity-chevron" aria-hidden="true">
    <i class="fa-regular fa-chevron-right"></i>
  </span>
</a>

<a class="activity-card activity-card-link" [routerLink]="worksheetsLink">
  <div class="activity-icon" aria-hidden="true">
    <i class="fa-regular fa-book-open"></i>
  </div>

  <div class="activity-info">
    <span class="title-medium-emphasized">Brogliacci</span>
    <span class="body-medium">Brogliacci confermati da inserire in distinta</span>
  </div>

  <span class="activity-count label-small-emphasized">
    {{ brogliacciCount }}
  </span>

  <span class="activity-chevron" aria-hidden="true">
    <i class="fa-regular fa-chevron-right"></i>
  </span>
</a>

<a class="activity-card activity-card-link" [routerLink]="depositsLink">
  <div class="activity-icon" aria-hidden="true">
    <i class="fa-regular fa-database"></i>
  </div>

  <div class="activity-info">
    <span class="title-medium-emphasized">Distinte di versamento</span>
    <span class="body-medium">Versamenti presentati in banca da chiudere</span>
  </div>

  <span class="activity-count label-small-emphasized">
    {{ distinteCount }}
  </span>

  <span class="activity-chevron" aria-hidden="true">
    <i class="fa-regular fa-chevron-right"></i>
  </span>
</a>

<button
  matFab
  extended
  type="button"
  class="new-revenue-button"
  *uiCan="CAPS.incassoCrea"
  [routerLink]="newReceiptLink"
>
  <i class="fa-regular fa-plus" aria-hidden="true"></i>
  <span class="new-revenue-label title-medium">Nuovo incasso</span>
</button>
